import { IPermissionForKey, IPermissionKey } from "shared/types";

export const userHasPermission = (
  permissions?: IPermissionForKey[],
  type?: IPermissionKey
): boolean => {
  if (permissions && type) {
    return mapUserPermissions(permissions)?.[type] || false;
  }
  return false;
};

export type IUserPermissions = { [key in IPermissionKey]?: boolean };

export const mapUserPermissions = (
  permissions: IPermissionForKey[]
): IUserPermissions => {
  return permissions.reduce(
    (mappedPermissions, { permission, granted }) => ({
      ...mappedPermissions,
      [permission]: granted,
    }),
    {}
  );
};
